import React, { useEffect, useState } from "react";
import { Row, Col, Card, Form } from "react-bootstrap";
import { Link } from 'react-router-dom';

const langOptions = [
    { value: "ar", label: "Arabo" },
    { value: "de", label: "Tedesco" },
    { value: "en", label: "Inglese" },
    { value: "it", label: "Italiano" },
    { value: "es", label: "Spagnolo" },
    { value: "fr", label: "Francese" },
    { value: "ru", label: "Russo" },
];

const emptyForm = {
    givenName: '', familyName: '', birthdate: '', gender: '', nationality: '',
    streetAddress: '', locality: '', country: '', postalCode: '',
    province: '', languagesLabel: '',
};

const ReadOnlyField = ({ label, value, type = 'text' }) => (
    <Form.Group className="mb-3">
        <Form.Label>{label}</Form.Label>
        <Form.Control className="sid-ro-input" type={type} value={value || ''} readOnly tabIndex={-1} />
    </Form.Group>
);

const DatiAnagraficiJunior = (props) => {
    const [form, setForm] = useState(emptyForm);
    const [parent, setParent] = useState(null);

    useEffect(() => {
        const j = props.profile && props.profile.junior;
        if (!j) return;

        const address = j.address || {};
        let languagesLabel = '';
        if (Array.isArray(j.spokenLocales)) {
            languagesLabel = j.spokenLocales
                .map((v) => (langOptions.find((o) => o.value === v) || {}).label)
                .filter(Boolean)
                .join(', ');
        }

        setForm({
            givenName: j.givenName || '',
            familyName: j.familyName || '',
            birthdate: j.birthdate || '',
            gender: j.gender || '',
            nationality: j.nationality || '',
            streetAddress: address.streetAddress || '',
            locality: address.locality || '',
            country: address.country || '',
            postalCode: address.postalCode || '',
            province: address.province || '',
            languagesLabel,
        });

        setParent(j.parent || null);
    }, [props.profile]);

    const genderLabel = form.gender
        ? (form.gender.toUpperCase().startsWith('M') ? 'Maschio' : form.gender.toUpperCase().startsWith('F') ? 'Femmina' : form.gender)
        : '';
    const countryLabel = form.country === 'IT' ? 'Italia' : form.country;
    const parentName = parent ? `${parent.givenName || ''} ${parent.familyName || ''}`.trim() : '';

    return (
        <Row>
            <Col lg={6}>
                <Card>
                    <Card.Header><Card.Title>Dati anagrafici</Card.Title></Card.Header>
                    <Card.Body>
                        <ReadOnlyField label="Nome" value={form.givenName} />
                        <ReadOnlyField label="Cognome" value={form.familyName} />
                        <ReadOnlyField label="Data di nascita" value={form.birthdate} type="date" />
                        <ReadOnlyField label="Sesso" value={genderLabel} />
                        <ReadOnlyField label="Nazionalità" value={form.nationality} />
                        <ReadOnlyField label="Indirizzo" value={form.streetAddress} />
                        <ReadOnlyField label="Località" value={form.locality} />
                        <ReadOnlyField label="Provincia" value={form.province} />
                        <ReadOnlyField label="CAP" value={form.postalCode} />
                        <ReadOnlyField label="Paese" value={countryLabel} />
                    </Card.Body>
                </Card>
            </Col>
            <Col lg={6}>
                <Card>
                    <Card.Header><Card.Title>Senior collegato</Card.Title></Card.Header>
                    <Card.Body>
                        <Form.Group className="mb-0">
                            <Form.Label>Player senior</Form.Label>
                            <div className="form-control sid-ro-input d-flex align-items-center">
                                {parent
                                    ? <Link to={`/struttura/clienti/player_profile/${parent.userId}`} style={{ color: '#E8721C', fontWeight: 600 }}>{parentName}</Link>
                                    : '-'}
                            </div>
                        </Form.Group>
                    </Card.Body>
                </Card>
                <Card>
                    <Card.Header><Card.Title>Altri dati</Card.Title></Card.Header>
                    <Card.Body>
                        {/*
                            Niente descrizione: non esiste un posto da cui scriverla -
                            non l'app, non il gestionale, non il superadmin - quindi
                            qui compariva sempre e solo un riquadro vuoto.
                        */}
                        <ReadOnlyField label="Lingue parlate" value={form.languagesLabel} />
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

export default DatiAnagraficiJunior;
